import { fetchTranslations, updateTranslations } from "./dbutils";

export async function initPageTranslations(phrases, page) {
  const lang = localStorage.getItem("language") || "vie";
  var trs = await fetchTranslations(lang, page);
  if (!trs) {
    trs = { language: lang, page: page, phrases: {} };
  }
  var tr = {};
  for (var phrase of phrases) {
    if (trs.phrases[phrase] === undefined) {
      trs.phrases[phrase] = lang === "en" ? phrase : "";
    }
    tr[phrase] = trs.phrases[phrase] ? trs.phrases[phrase] : phrase;
  }
  await updateTranslations(trs);
  return tr;
}

export function getDefaultAvailableTimeslots() {
  const daylabels = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

  var a = [];
  for (var nd = 0; nd < daylabels.length; nd++) {
    const ad = { day: daylabels[nd], dayIndex: nd, slots: [0, 0, 0, 0] };
    a.push(ad);
  }
  return a;
}

export function availableSlots(avs, ndays, height, width) {
  const wdaylabels =
    ndays === 5
      ? ["MON", "TUE", "WED", "THU", "FRI"]
      : ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  const slotlabels = ["", "", "", ""];
  const timeLabels = [
    "8.30am – 10.30am",
    "10.30am – 12.30pm",
    "12.30pm – 3.00pm",
    "3.00pm – 5.00pm",
  ];
  const labelclass = "text-center text-[8px] h-[" + height + "px]";
  const windowclass = "flex flex-col w-full h-[" + (height + 1) * 5 + "px]";
  return (
    <div className={windowclass}>
      <table className="min-w-full">
        <thead className="text-current">
          {wdaylabels.map((dl) => (
            <th
              key={dl}
              scope="col"
              // style={{
              //   // minHeight: height,
              //   height: height,
              //   // minWidth: width,
              //   width: width,
              // }}
              className={labelclass}
            >
              {dl}
            </th>
          ))}
        </thead>
        <tbody className="">
          {slotlabels.map((sl, i) => (
            <tr className="" style={{ height: height, width: width }}>
              {avs &&
                avs
                  .filter((obj) => wdaylabels.includes(obj.day))
                  .map((tsav, j) => (
                    <td className="text-center">
                      <div
                        style={{ height: height, width: width }}
                        className={
                          tsav.slots[i] === 1 ? "bg-success" : "bg-error"
                        }
                      >
                        {width <= 20 ? (
                          <></>
                        ) : (
                          <p className="text-[8px] text-center text-white p-1">
                            {timeLabels[i]}
                          </p>
                        )}
                      </div>
                    </td>
                  ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function guideTextColour(guide) {
  if (!guide || !guide.scheduleColour) return "";
  if (
    pickTextColorBasedOnBgColorAdvanced(
      guide.scheduleColour,
      "#FFFFFF",
      "#000000"
    ) === "#FFFFFF"
  ) {
    return "text-center text-white";
  }
  return "text-center text-black";
}

export function pickTextColorBasedOnBgColorAdvanced(
  bgColor,
  lightColor,
  darkColor
) {
  var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  var r = parseInt(color.substring(0, 2), 16); // hexToR
  var g = parseInt(color.substring(2, 4), 16); // hexToG
  var b = parseInt(color.substring(4, 6), 16); // hexToB
  var uicolors = [r / 255, g / 255, b / 255];
  var c = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  return L > 0.179 ? darkColor : lightColor;
}

export function getAge(dob) {
  var today = new Date();
  var birthDate = new Date(dob * 1000);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

// base64 to buffer
function base64ToBufferAsync(base64) {
  var dataUrl = "data:application/octet-binary;base64," + base64;

  fetch(dataUrl)
    .then((res) => res.arrayBuffer())
    .then((buffer) => {
      console.log("base64 to buffer: " + new Uint8Array(buffer));
    });
}

// buffer to base64
async function bufferToBase64Async(buffer) {
  var blob = new Blob([buffer], { type: "application/octet-binary" });
  console.log("buffer to blob:" + blob);

  var fileReader = new FileReader();
  fileReader.onload = async function () {
    var dataUrl = fileReader.result;
    console.log("blob to dataUrl: " + dataUrl);

    var base64 = dataUrl.substr(dataUrl.indexOf(",") + 1);
    console.log("dataUrl to base64: " + base64);
    return base64;
  };
  fileReader.readAsDataURL(blob);
}

export function processTRXFiles(buffer) {
  let events = [];
  let headers = [];
  const lines = buffer.split(/\r?\n/);
  const trx = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    const tokens = line.split(",");
    if (i === 0) {
      for (let j = 0; j < tokens.length; j++) {
        headers.push(tokens[j].trim());
      }
    } else {
      const obj = {};
      for (let j = 0; j < tokens.length; j++) {
        obj[headers[j]] = tokens[j].trim();
      }
      obj["ORDER"] = i;
      events.push(obj);
    }
  }
  return events;
}

export function writeText(info, style = {}) {
  const { ctx, text, x, y, width } = info;
  const {
    fontSize = 20,
    fontFamily = "Arial",
    color = "black",
    textAlign = "left",
    textBaseline = "top",
  } = style;

  ctx.beginPath();
  // ctx.font = "condensed " + fontSize + "px " + fontFamily;
  ctx.font = fontSize + "px " + fontFamily;
  ctx.textAlign = textAlign;
  ctx.textBaseline = textBaseline;
  ctx.fillStyle = color;
  ctx.fillText(text, x, y);
  ctx.stroke();
}

export function writeTextCentre(info, style = {}) {
  const { ctx, text, x, y, width } = info;
  const { fontFamily = "segoe", color = "black", textBaseline = "top" } = style;

  var textWidth = ctx.measureText(text).width;
  var xx = x + width / 2 - textWidth / 2;

  ctx.beginPath();
  ctx.font = info.fontsize + "px " + fontFamily;
  ctx.textAlign = "centre";
  ctx.textBaseline = textBaseline;
  ctx.fillStyle = color;
  ctx.fillText(text, xx, y);
  ctx.stroke();
}

export function convertSecondsToMinutesSeconds(str) {
  const seconds = parseInt(str, 10);
  const minutes = Math.floor(seconds / 60);
  let mstr = minutes.toString();
  if (mstr.length < 2) {
    mstr = "0" + mstr;
  }
  const remainingSeconds = seconds % 60;
  return `${mstr}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
}

export function getChainData(e, team, match) {
  const chainid = e["INITIAL_TRX_ID"];
  const period = parseInt(e["PERIOD"]);
  const evs = team.events[period - 1].filter((event) => {
    return event["INITIAL_TRX_ID"] === chainid;
  });

  const catapultOffset = match.periods[period - 1].catapultOffset;
  const starttime =
    match.home_catapult_session?.periods[period - 1].start_time +
    catapultOffset;

  let lastev = null;
  for (var ev of evs) {
    const plid = ev["PERSON_ID"];
    const pls = team.cdplayers.filter((p) => {
      return p.id === plid;
    });
    if (pls.length > 0) {
      const athlete_id = pls[0].athlete_id;
      const sds = team.playerSensorData[period - 1].filter((sd) => {
        return sd.id === athlete_id;
      });
      const sdx = sds[0];
      if (sdx && sdx.data) {
        for (var sd of sdx.data.data) {
          const sdtime = sd.ts + sd.cs / 100;
          const etime =
            parseInt(ev["PERIOD_SECS"]) +
            parseFloat(match.periods[period - 1].firstBounceVideoTime);
          if (sdtime >= starttime + etime) {
            ev["chainx"] = sd.x;
            ev["chainy"] = sd.y;
            if (lastev) {
              const lastx = lastev["chainx"];
              const lasty = lastev["chainy"];
              // distance
              let dist = 0;
              if (
                ev["STATISTIC_CODE"] === "GOAL" ||
                ev["STATISTIC_CODE"].substring(0, 3) === "RUS" ||
                ev["STATISTIC_CODE"] === "BEHI"
              ) {
                const halflength = parseInt(match.venueLength) / 2;
                if (lastx <= 0) {
                  dist = Math.sqrt(
                    Math.pow(-halflength - lastx, 2) + Math.pow(0 - lasty, 2)
                  );
                } else {
                  dist = Math.sqrt(
                    Math.pow(halflength - lastx, 2) + Math.pow(0 - lasty, 2)
                  );
                }
              } else {
                dist = Math.sqrt(
                  Math.pow(sd.x - lastx, 2) + Math.pow(sd.y - lasty, 2)
                );
              }
              lastev["distance"] = dist;
            }
            lastev = ev;
            break;
          }
        }
      }
    }
  }
  const chaindata = {
    chainId: chainid,
    chainSquad: e["CHAIN_SQUAD"],
    events: evs,
  };

  return chaindata;
}

export function addAlPhatoRGBColour(rgbcol, alpha) {
  const regex = /rgb\(([0-9]*)[,\s]*([0-9]*)[,\s]*([0-9]*)\)/gm;
  const str = rgbcol;
  let m;
  while ((m = regex.exec(str)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    let s = "rgba(";
    m.forEach((match, groupIndex) => {
      // console.log(`Found match, group ${groupIndex}: ${match}`);
      if (groupIndex > 0) {
        s += `${match}, `;
      }
    });
    s += alpha + ")";
    return s;
  }
  return "";
}

export function getXYOfPlayerByTime(pl, time) {
  for (var n = 0; n < pl?.data?.length; n++) {
    const sd = pl.data[n];
    const sdtime = sd.ts + sd.cs / 100;
    if (sdtime >= time) {
      if (sd.x === 0 && sd.y === 0) {
        continue;
      }
      return { x: sd.x, y: sd.y };
    }
  }
  return null;
}

export function calculateDistanceToBall(
  player,
  ballcarrier,
  selectedPeriod,
  currentTime
) {
  // calculate distance from activePlayer to sensorData
  if (!ballcarrier || !player) {
    return null;
  }
  if (
    ballcarrier.playerSensorData[selectedPeriod - 1] &&
    player.playerSensorData[selectedPeriod - 1]
  ) {
    const ballPosition = getXYOfPlayerByTime(
      ballcarrier.playerSensorData[selectedPeriod - 1],
      currentTime
    );
    const playerPosition = getXYOfPlayerByTime(
      player.playerSensorData[selectedPeriod - 1],
      currentTime
    );

    const distance = Math.sqrt(
      Math.pow(ballPosition.x - playerPosition.x, 2) +
        Math.pow(ballPosition.y - playerPosition.y, 2)
    );
    return distance.toFixed(2);
  }
  return null;
}
